  let items = document.querySelector(".list-menu--inline").querySelectorAll("details");
  
  items.forEach(item => {
    let submenu = item.querySelector("ul");
    
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
    });

    item.addEventListener("mouseleave", (event) => {
      if (!isMouseWithinBounds(item, event) && !isMouseWithinBounds(submenu, event)) {
        item.removeAttribute("open");
      }
    });
  });

  // Function to check if mouse is within bounds of an element
  function isMouseWithinBounds(element, event) {
    const rect = element.getBoundingClientRect();
    return (
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    );
  }

  // Global click event listener to close submenu when clicking outside
  document.body.addEventListener("click", (event) => {
    const isClickInsideMenu = event.target.closest(".list-menu--inline") !== null;
    if (!isClickInsideMenu) {
      items.forEach(item => {
        item.removeAttribute("open");
      });
    }
  });



/* ------------------------------------------------------------ *\
  Ticker component
\* ------------------------------------------------------------ */
if (!customElements.get('ticker-component')) {
  customElements.define('ticker-component', class ticker extends HTMLElement {
    constructor() {
      super();

      this.ticker = this.querySelector('[data-ticker]');
      this.items = this.querySelector('[data-ticker-items]');
      this.isRunning = false;
      this.isPaused = false;
      this.timeIndex = Number(this.dataset.speed) || 1.63; // seconds
      this.space = 100; // px, animate through "space" px for "timeIndex" seconds
      this.forcePlay = this.dataset.forcePlay == 'true' ? true : false;
      this.sourceContainer = this.ticker.children[0];
      this.textIsBiggerThanContainer = this.sourceContainer.clientWidth > this.ticker.clientWidth;
      this.animationContainers = Array.from(this.ticker.children);
      this.classes = { paused: 'paused' };

      this.init();
      console.log(this.sourceContainer.clientWidth + " BROWSER WIDTH");
      console.log(this.ticker.clientWidth + " TICKER WIDTH");
    }

    updateAnimationContainers() {
      this.animationContainers = Array.from(this.ticker.children);
    }

    updateSourceContainer() {
      if (!this.ticker.children.length) throw new Error('Child container not found in announcement-bar-ticker.liquid');
      this.sourceContainer = this.ticker.children[0];
    }

    updateTextIsBiggerThanContainer() {
      this.textIsBiggerThanContainer = this.sourceContainer.clientWidth > this.ticker.clientWidth;
    }

    init() {
      this.setAnimationCSSVariable();
      this.handleAnimation();
      
      window.addEventListener('load', () => {
        this.updateTicker();
      });

      window.addEventListener('resize', () => {
        this.updateTicker();
      });

      this.addEventListener('mouseenter', () => {
        this.pause();
      });

      this.addEventListener('mouseleave', () => {
        this.play();
      });
    }

    updateVariables() {
      this.updateSourceContainer();
      this.updateTextIsBiggerThanContainer();
      this.updateAnimationContainers();
    }

    updateTicker() {
      this.updateVariables();
      this.handleAnimation();
    }
    
    setAnimationCSSVariable() {
      const animationTimeFrame = (this.sourceContainer.clientWidth / this.space) * this.timeIndex;
      this.ticker.style.setProperty('--animation-time', `${animationTimeFrame.toFixed(1)}s`);
    }

    handleAnimation() {
      if (this.forcePlay) {
        this.animate();
      } else {
        this.animateWhenNecessary();
      }

      // We need to restart the animation when we add more items to avoid аnimation desync
      this.resetAnimation();
    }

    animate() {
      // Keep cloning the items until marquee starts to overflow
      // and then add one additional item to ensure we have enough items to properly animate
      while (
        this.ticker.scrollWidth <=
        this.ticker.clientWidth + this.sourceContainer.getBoundingClientRect().width
      ) {
        this.cloneAndAppendItems();
      }

      this.play();
    }
    
    animateWhenNecessary() {
      if (this.textIsBiggerThanContainer) {
        if (this.isRunning) return;

        this.cloneAndAppendItems();
      } else {
        if (this.animationContainers.length < 2) return;
        
        const [_originalItem, ...clones] = this.animationContainers;
        clones.forEach((clone) => clone.remove()); // Kill clones only and keep the original item, the ticker is now paused
        this.updateVariables();
      }

      this.isRunning = this.textIsBiggerThanContainer;
      this.isPaused = !this.textIsBiggerThanContainer;
      this.querySelectorAll('[data-ticker-items]').forEach((element) => element.classList.toggle('paused', !this.textIsBiggerThanContainer));

      if (!this.forcePlay) this.ticker.style.transform = '';
    }

    cloneAndAppendItems() {
      const clone = this.sourceContainer.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true'); // Prevent voice-over from announcing the clones
      this.ticker.appendChild(clone); // Add clones
      this.updateVariables();
    }

    resetAnimation() {
      this.animationContainers.forEach((element) => {
        element.style.animation = 'none';
        setTimeout(() => {
          element.style.animation = '';
        }, 50);
      });
    }

    play() {
      this.ticker.style.transform = '';

      if (this.forcePlay || this.textIsBiggerThanContainer) {
        this.isRunning = true;
        this.isPaused = false;
        this.items.classList.remove(this.classes.paused);
      }
    }

    pause() {
      this.isPaused = true;
      this.items.classList.add(this.classes.paused);
    }
  });
}

/* Calc full-screen height */
const calcVariables = () => {
  const headerHeight = document.querySelector('.shopify-section__header')?.clientHeight;
  const windowHeight = window.innerHeight;
  const announcementBarHeight = document.querySelector('.shopify-section--announcement-bar')?.clientHeight;
  document.documentElement.style.setProperty('--full-screen', `${windowHeight}px`);
  headerHeight && document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  announcementBarHeight && document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);
}

calcVariables();

window.addEventListener('resize', () => {
  calcVariables();
});

/* Mobile Menu & Cart Drawer buttons */
(() => {
  const menuButton = document.querySelector('.header__mobile-nav');
  const cartButton = document.querySelector('.header__action-item--cart');
  const header = document.querySelector('.header');
  
  const lockBody = () => {
    const bodyIsLocked = document.body.classList.contains('no-mobile-scroll');
    bodyIsLocked 
      ? bodyScrollLock.disableBodyScroll(header)
      : bodyScrollLock.enableBodyScroll(header);
  }

  menuButton?.addEventListener('click', lockBody);
  cartButton?.addEventListener('click', lockBody);

  document.addEventListener('click', () => {
    if (!document.body.classList.contains('no-mobile-scroll')) {
      document.body.classList.remove('no-mobile-scroll');
      requestAnimationFrame(() => {
        document.body.style.overflow = '';
      });
    }
  });
})();